<div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="start center" fxFlex.gt-sm="100" [formGroup]="authorFormGroup">
    <!-- <p>myForm value: {{ authorFormGroup.value | json }}</p> -->
    <div *ngIf="isAuthorShow" class="mr-20">

        <mat-form-field class="full-width-multi-select" floatLabel="always" [ngClass]="{
            'form-validator-message-text':
                authorFormGroup.get('robutsAuthorType').touched &&
                authorFormGroup.get('Tipo').invalid
        }">
            <mat-label>Autor</mat-label>
            <mat-select (selectionChange)="OnAuthorChange($event)" formControlName="Tipo">
                <mat-option *ngFor="let option of authorListWithPremist" [value]="option.value">
                    {{ option.viewValue }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <!-- Errors will be displayed from old tipo controller -->
        <mat-error *ngIf="
            authorFormGroup.get('Tipo') &&
            authorFormGroup.get('Tipo').invalid
        ">
            <span *ngIf="
                authorFormGroup.get('Tipo') &&
                authorFormGroup.get('Tipo').errors.required
            " class="validation-span">Obligatorio</span>
        </mat-error>

    </div>


    

    <div *ngIf="dropDownActivate.gestion">
        <div class="mr-20" [ngSwitch]="this.moduleName=='task-selection'">
            <mat-form-field floatLabel="never" *ngSwitchCase="true">
                <mat-label>Usuario</mat-label>
                <mat-select class="full-width-multi-select" [formControl]="Usuario" multiple (selectionChange)="OnUserChange($event)"  [sortComparator]="noCompareFunction">
                  <mat-option *ngFor="let user of userList" [value]="user.value">{{user.viewValue}}</mat-option>
                </mat-select>
              </mat-form-field>

              <div *ngSwitchCase="false">
                    <mat-form-field class="full-width-multi-select" floatLabel="always" floatLabel="always" [ngClass]="{
                        'form-validator-message-text':
                            authorFormGroup.get('Usuario').touched &&
                            authorFormGroup.get('Usuario').invalid
                    }">
                    <mat-label>Usuario</mat-label>
                    <mat-select formControlName="Usuario" (selectionChange)="OnUserChange($event)">
                        <mat-option *ngFor="let option of userList" [value]="option.value">
                            {{ option.viewValue }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-error *ngIf="
                        authorFormGroup.get('Usuario') &&
                        authorFormGroup.get('Usuario').invalid
                    ">
                    <span *ngIf="
                            authorFormGroup.get('Usuario') &&
                            authorFormGroup.get('Usuario').errors.required
                        " class="validation-span">Obligatorio</span>
                </mat-error>
              </div>
            <!-- <some-element *ngSwitchCase="false">...</some-element> -->
        </div>
    </div>
    <div class="mr-20" *ngIf="dropDownActivate.medico">
        <!-- <mat-form-field  class="full-width-multi-select" floatLabel="always">
            <mat-label>Medico</mat-label>
            <mat-select (selectionChange)="OnValueChange($event, 'doctor')"  [(ngModel)]="defaultMedicoValue">
                <mat-option *ngFor="let option of medicoList" [value]="option.value">
                    {{option.viewValue}}
                </mat-option>
            </mat-select>
        </mat-form-field> -->

        <mat-form-field class="full-width-multi-select" floatLabel="always" floatLabel="always" [ngClass]="{
                'form-validator-message-text':
                    authorFormGroup.get('Medico').touched &&
                    authorFormGroup.get('Medico').invalid
            }">
            <mat-label>Medico</mat-label>
            <mat-select panelClass="cus-search-select" formControlName="Medico"
                (selectionChange)="OnUserChange($event)">
                <input type="text" autocomplete="off" matInput placeholder="búsqueda" #medicoSelect
                    (input)="SearchDoctors()" />
                <div class="search-options">
                    <mat-option *ngFor="let option of _medicoList" [value]="option.value">
                        {{ option.viewValue }}
                    </mat-option>
                </div>

            </mat-select>
        </mat-form-field>
        <mat-error *ngIf="
                authorFormGroup.get('Medico') &&
                authorFormGroup.get('Medico').invalid
            ">
            <span *ngIf="
                    authorFormGroup.get('Medico') &&
                    authorFormGroup.get('Medico').errors.required
                " class="validation-span">Obligatorio</span>
        </mat-error>

    </div>

    <div class="mr-20" *ngIf="dropDownActivate.due">
        <!-- <mat-form-field  class="full-width-multi-select" floatLabel="always">
            <mat-label>Medico</mat-label>
            <mat-select (selectionChange)="OnValueChange($event, 'doctor')"  [(ngModel)]="defaultMedicoValue">
                <mat-option *ngFor="let option of medicoList" [value]="option.value">
                    {{option.viewValue}}
                </mat-option>
            </mat-select>
        </mat-form-field> -->

        <mat-form-field class="full-width-multi-select" floatLabel="always" floatLabel="always" [ngClass]="{
                'form-validator-message-text':
                    authorFormGroup.get('Medico').touched &&
                    authorFormGroup.get('Medico').invalid
            }">
            <mat-label>Medico</mat-label>
            <mat-select panelClass="cus-search-select" formControlName="Medico"
                (selectionChange)="OnUserChange($event)" multiple>
                <div class="search-options">
                    <mat-option *ngFor="let option of _medicoList" [value]="option.value">
                        {{ option.viewValue }}
                    </mat-option>
                </div>

            </mat-select>
        </mat-form-field>
        <mat-error *ngIf="
                authorFormGroup.get('Medico') &&
                authorFormGroup.get('Medico').invalid
            ">
            <span *ngIf="
                    authorFormGroup.get('Medico') &&
                    authorFormGroup.get('Medico').errors.required
                " class="validation-span">Obligatorio</span>
        </mat-error>

    </div>

    <div class="mr-20" *ngIf="dropDownActivate.coordinador">
        <mat-form-field class="full-width-multi-select" floatLabel="always" floatLabel="always" [ngClass]="{
                'form-validator-message-text':
                    authorFormGroup.get('Coordinator').touched &&
                    authorFormGroup.get('Coordinator').invalid
            }">
            <mat-label>Coordinador</mat-label>
            <mat-select formControlName="Coordinator" (selectionChange)="OnUserChange($event)">
                <mat-option *ngFor="let option of coordinatorList" [value]="option.value">
                    {{ option.viewValue }}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-error *ngIf="
                authorFormGroup.get('Coordinator') &&
                authorFormGroup.get('Coordinator').invalid
            ">
            <span *ngIf="
                    authorFormGroup.get('Coordinator') &&
                    authorFormGroup.get('Coordinator').errors.required
                " class="validation-span">Obligatorio</span>
        </mat-error>
    </div>

</div>